import { TrainingTab } from './TrainingTab.tsx';

export function CompanyTraining() {
  return <TrainingTab apiPrefix="/api/me" />;
}
